module.exports = __webpack_public_path__ + "img/main.55ff027e.jpg";